export default __webpack_public_path__ + "static/media/Shuffle.fe6cdf49.svg";